// Function to check if we're in the Christmas period
export const isChristmasPeriod = () => {
  // For testing: uncomment the line below to always show Christmas theme
  // return true;
  
  const now = new Date();
  const startDate = new Date(2025, 11, 1); // December 1, 2025 (month is 0-indexed)
  const endDate = new Date(2026, 0, 14); // January 14, 2026 (month is 0-indexed)
  return now >= startDate && now < endDate;
};

// Helper function to get Christmas-themed color classes
export const getChristmasColor = (blueClass, redClass) => {
  return isChristmasPeriod() ? redClass : blueClass;
};

